import { createApi } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL } from '@/config';
import { nonAbortingSignalBaseQuery } from '@/store/services/baseQuery';

export const USERS_TAG = 'Users';

const adminApi = createApi({
    baseQuery: nonAbortingSignalBaseQuery,
    endpoints: (builder) => ({
        createUser: builder.mutation({
            invalidatesTags: [USERS_TAG],
            query: (body) => ({
                body,
                method: 'POST',
                url: `${API_BASE_URL}/admin/users`,
            }),
        }),
        disableUser: builder.mutation({
            invalidatesTags: [USERS_TAG],
            query: (userId) => ({
                method: 'POST',
                url: `${API_BASE_URL}/admin/users/${userId}/disable`,
            }),
        }),
        enableUser: builder.mutation({
            invalidatesTags: [USERS_TAG],
            query: (userId) => ({
                method: 'POST',
                url: `${API_BASE_URL}/admin/users/${userId}/enable`,
            }),
        }),
        getUsers: builder.query({
            providesTags: [USERS_TAG],
            query: () => `${API_BASE_URL}/admin/users`,
        }),
        resetUserPassword: builder.mutation({
            invalidatesTags: [USERS_TAG],
            query: (userId) => ({
                method: 'POST',
                url: `${API_BASE_URL}/admin/users/${userId}/reset-password`,
            }),
        }),
    }),
    reducerPath: 'adminApi',
    tagTypes: [USERS_TAG],
});

export const {
    useCreateUserMutation,
    useDisableUserMutation,
    useEnableUserMutation,
    useGetUsersQuery,
    useResetUserPasswordMutation,
} = adminApi;
export default adminApi;
